import React, { useEffect } from 'react';
import { CircularProgress, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import SubscriptionPlanCardInManage from '../../components/SubscriptionPlanCardInManage/SubscriptionPlanCardInManage';
import {
  activateFreePlan,
  createCheckoutSession,
  getSubscriptionPlansRequest,
  ISubscriptionPlans,
} from '../../redux/subscription/subscriptionSlice';
import { SubscriptionPlanTypes } from '../../types/coach';
import CustomModal from '../../components/Common/CustomModal';
import SubscriptionUpdateModal from '../../components/SubscriptionUpdateModal/SubscriptionUpdateModal';
import { CHECKOUT_PAGE_ROUTE } from '../../utils/routes';

export default function SubscriptionPlanManage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const coach = useAppSelector((state) => state.coach.coach);
  const subscriptionPlans = useAppSelector((state) => state.subscription.subscriptionPlans);
  const { getSubscriptionPlansLoading } = useAppSelector((state) => state.subscription);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [selectedPlan, setSelectedPlan] = React.useState<SubscriptionPlanTypes | null>(null);
  const clientCountStatus = useAppSelector((state) => state.coach.coach.clientCountStatus);

  const getCurrentPlan = () => {
    if (coach.subscriptionPlanStatus) {
      return coach.subscriptionPlanStatus?.currentPlan;
    }
    return SubscriptionPlanTypes.NONE;
  };

  useEffect(() => {
    if (coach.id) {
      dispatch(getSubscriptionPlansRequest({ coachId: coach.id }));
    }
  }, [coach.id, dispatch]);

  const currentPlan = getCurrentPlan();
  let filteredPlans: ISubscriptionPlans[];
  if (currentPlan === SubscriptionPlanTypes.PREMIUM) {
    filteredPlans = subscriptionPlans.filter((plan) => plan.name === SubscriptionPlanTypes.PREMIUM);
  } else {
    filteredPlans = subscriptionPlans.filter((plan) => plan.rank >= 0);
  }

  const handlePaymentNavigate = (value: SubscriptionPlanTypes) => {
    setSelectedPlan(value);
    const currentPlanRank = subscriptionPlans.find((p) => p.name === currentPlan)?.rank || -1;
    if (value === SubscriptionPlanTypes.FREE && currentPlanRank < 0) {
      dispatch(activateFreePlan({ coachId: coach.id }));
    } else if (currentPlanRank < 1) {
      dispatch(createCheckoutSession({ coachId: coach.id, planType: value }));
      navigate(CHECKOUT_PAGE_ROUTE);
    } else {
      setIsModalOpen(true);
    }
  };

  const handleDowngrade = (value: SubscriptionPlanTypes) => {
    setSelectedPlan(value);
    setIsModalOpen(true);
  };

  return (
    <CoachPageLayout>
      <Grid
        container
        spacing={1.5}
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '90vh' }}
        overflow="hidden"
        alignContent={{ xs: 'center', md: 'center' }}
      >
        {getSubscriptionPlansLoading ? (
          <Grid item>
            <CircularProgress />
          </Grid>
        ) : (
          filteredPlans.map((plan) => (
            <Grid item key={plan.id} xs={12} sm={6} md={6} lg={3}>
              <SubscriptionPlanCardInManage
                plan={plan}
                currentPlan={currentPlan}
                handlePaymentNavigate={handlePaymentNavigate}
                handleDowngrade={handleDowngrade}
              />
            </Grid>
          ))
        )}
      </Grid>
      <CustomModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} xs={3.3}>
        <SubscriptionUpdateModal
          onClose={() => setIsModalOpen(false)}
          maxClients={coach.subscriptionPlan?.maxUserCount}
          clientCountStatus={clientCountStatus}
          plan={selectedPlan}
          currentPlan={currentPlan}
        />
      </CustomModal>
    </CoachPageLayout>
  );
}
